/**
 * Adjusts the height of the element with the ID 'desktop-spacer' to match the
 * outer height (including margin) of the element with the class 'checkout-notice'.
 */

export function sizeDesktopSpacer() {
    const spacer = document.getElementById('desktop-spacer');
    const note = document.querySelector('.checkout-notice');

    if (spacer && note) {
        const style = window.getComputedStyle(note);
        const height = note.offsetHeight 
                    + parseFloat(style.marginTop) 
                    + parseFloat(style.marginBottom);
        spacer.style.height = height + 'px';
    }
}